import { INVENTORY_STATUS } from '@onward-delivery/core';

// Presentation for the stages core resolves. The vocabulary and the ladder that picks one live in
// @onward-delivery/core, so this table and the shipper inventory API cannot drift; only the labels
// and tones are ours. Keep an entry for every INVENTORY_STATUS value -- a missing one renders as a
// dash rather than failing.
export const INVENTORY_STATUS_DISPLAY = {
    [INVENTORY_STATUS.ON_HOLD]: { label: 'On Hold', tone: 'destructive' },
    [INVENTORY_STATUS.ALLOCATED]: { label: 'Allocated', tone: 'info' },
    [INVENTORY_STATUS.STORED]: { label: 'Stored', tone: 'primary' },
    [INVENTORY_STATUS.PENDING_PUT_AWAY]: { label: 'Pending Put Away', tone: 'warning' },
    [INVENTORY_STATUS.IN_TRANSIT]: { label: 'In-Transit', tone: 'warning' },
    [INVENTORY_STATUS.RETURN_STORED]: { label: 'Return - Stored', tone: 'accent' },
    [INVENTORY_STATUS.RETURN_PENDING_PUT_AWAY]: { label: 'Return - Pending Put Away', tone: 'accent' },
    [INVENTORY_STATUS.RETURN_IN_TRANSIT]: { label: 'Return - In-Transit', tone: 'accent' },
    [INVENTORY_STATUS.RETURN_CREATED]: { label: 'Return - Created', tone: 'accent' },
    [INVENTORY_STATUS.RETURN_TRAILER_SCHEDULED]: { label: 'Return - Trailer Scheduled', tone: 'accent' },
    [INVENTORY_STATUS.RETURN_PICKED]: { label: 'Return - Picked', tone: 'accent' },
    [INVENTORY_STATUS.RETURN_STAGED]: { label: 'Return - Staged', tone: 'accent' },
    [INVENTORY_STATUS.RETURN_LOADED]: { label: 'Return - Loaded', tone: 'accent' },
};

// Dwell past three weeks is what the warehouse bills against, so it reads red.
export const DWELL_WARNING_DAYS = 21;

// The stock bar is scaled to the sku's thresholds. Absent ones fall back to a
// 0-100 range so a sku with no thresholds still renders a meaningful bar.
export const DEFAULT_STOCK_MIN = 0;
export const DEFAULT_STOCK_MAX = 100;

// Searching serials and line ids costs a round trip, so it waits for a pause in
// typing and for the term to be worth asking about. Two characters, because
// line ids in production are routinely that short.
export const ITEM_SEARCH_DEBOUNCE_MS = 300;
export const ITEM_SEARCH_MIN_LENGTH = 2;
export const ITEM_SEARCH_LIMIT = 200;

// Which party the viewer can narrow by; an account type with no entry gets no
// filter section. Both facets read the base view, not the SKU roll-up:
// forward_stocking_sku_summary nulls shipper_name whenever a SKU spans shippers,
// so filtering on that column would drop every multi-shipper SKU.
export const FACETS = {
    shipper: { key: 'carrier', label: 'Carrier', idField: 'carrier_id', nameField: 'carrier_name' },
    carrier: { key: 'shipper', label: 'Shipper', idField: 'shipper_id', nameField: 'shipper_name' },
};

export const facetFor = (accountType) => FACETS[accountType] || null;

/** Shown on a return-only SKU's On Hand and Stock Level, which count delivery stock. */
export const RETURN_ONLY_TITLE = 'Delivery On Hand and Stock Level count delivery stock. This SKU only has returns.';
